function JqueryDropShipmentModal() {
  const dropshipment_modal = $('#js-basket-drop-shipment-modal')
  const urlParams = new URLSearchParams(window.location.search)
  const dropshipment_modal_param = urlParams.get('dropshipment_modal')

  if (dropshipment_modal.length) {
    const open_dorpshipment_modal = function open_dorpshipment_modal() {
      let button = dropshipment_modal.find('#js-add-drop-shipment-button')
      let form = dropshipment_modal.find('#js-add-drop-shipment-form')
      let xhr = dropshipment_modal.find('#xhr-content')

      let url = form.attr('action')
      $.get(url, function (data) {
        xhr.html(data.html)
        button.removeClass('hidden')
      })

      button.on('click', function (event) {
        event.preventDefault()
        button.prop('disabled', true)

        $.post(url, form.serialize(), function (data) {
          if (data.status === 1) {
            location.reload()
            return
          }
          xhr.html(data.html)
          button.prop('disabled', false)
        })
      })

      let search_form = $('#js-search-form')
      let search_url = search_form.data('url')
      let search_input = search_form.find('input[name=search_term]')
      let clear_form_btn = $('.js-clear-btn')
      let clear_url = clear_form_btn.data('url')
      let address_modal_body = $('#select-address')
      let getContent = function (url) {
        $.get(url, search_form.serialize(),
          function (data) {
            address_modal_body.html(data.res)
          }
        )
      }

      getContent(clear_url)

      address_modal_body.on('click', '.list-group-item', function (event) {
        event.preventDefault()
        let url = $(this).attr('href')

        $.get(url, {override: '1'}, function () {
          window.location.reload()
        })
      })

      search_form.on('submit', function (event) {
        event.preventDefault()
        getContent(search_url)
      })

      clear_form_btn.on('click', function () {
        search_input.val('')
        getContent(clear_url)
      })
    }

    if (dropshipment_modal_param) {
      let params = new URLSearchParams(window.location.search)
      params.delete('dropshipment_modal')

      let new_url = `${window.location.protocol}//${window.location.host}${window.location.pathname}${params}`

      window.history.replaceState('', '', new_url);

      $(dropshipment_modal).modal('show')

      open_dorpshipment_modal()
    } else {
      $(dropshipment_modal).on('show.bs.modal', open_dorpshipment_modal())
    }
  }
}

export default JqueryDropShipmentModal
